import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CartState {
  isCartSidebarOpen: boolean;
  shopifyCartId: string | null;
}

const initialState: CartState = {
  isCartSidebarOpen: false,
  // Hydrated by useCart once the active user is known.
  shopifyCartId: null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartSidebarOpen(state, action: PayloadAction<CartState["isCartSidebarOpen"]>) {
      state.isCartSidebarOpen = action.payload;
    },
    setShopifyCartId(state, action: PayloadAction<CartState["shopifyCartId"]>) {
      state.shopifyCartId = action.payload;
    },
  },
});

export const { setCartSidebarOpen, setShopifyCartId } = cartSlice.actions;
export default cartSlice.reducer;
